import { defineComponent } from "vue";
import Modal from "@/components/Modal";
import TextField from "@/components/TextField";
import TextArea from "@/components/TextArea";
import FileField2 from "@/components/FileField2";
import NewButton from "@/components/NewButton";
import Checkbox from "@/components/Checkbox";
import adminServices from "@/services/admin";
import notify from "@/services/notify";
import Datepicker from "@/components/DatePicker";
import moment from "moment";
import MultiSelectField from "@/components/MultiSelectField";
import Table, { debounce } from "@/components/Table";
import { parseTimeTz, convertTZ, mapTime, convertTimeTZ } from "@/misc/commons";
import ArrowIcon from "@/assets/images/icon/icon-arrow.svg";
import SelectField from "@/components/SelectField";

export default defineComponent({
  name: "NotificationModal",
  props: ["reload"],
  components: {
    Modal,
    TextField,
    TextArea,
    NewButton,
    FileField2,
    Checkbox,
    Datepicker,
    MultiSelectField,
    Table,
    ArrowIcon,
    SelectField,
  },
  data() {
    return {
      isShow: false,
      state: "CREATE",
      loading: false,
      loadingView: false,
      title: "",
      content: "",
      file: null,
      url: null,
      convertTZ,
      useSchedule: false,
      datetime: null,
      tmpDate: null,
      usersGetNoti: [],
      errorMsg: {
        title: "",
        content: "",
        file: "",
        datetime: "",
        selectUser: "",
      },
      addNotiUsers: false,

      rows: [],
      totalItems: 0,
      investorDataLoading: false,
      paging: {
        page: 1,
        size: 10,
        total: 0,
      },
      filteredName: "",
      filteredEmail: "",
      filteredStatus: null,
      orderBy: "",
      columns: [
        {
          id: "name",
          name: "Name",
          // sort: true,
          // direction: ''
        },
        {
          id: "email",
          name: "Email",
          direction: "",
        },
        {
          id: "is_device",
          name: "App installed",
          direction: "",
        },
        {
          id: "actions",
          name: "",
          titleClass: "text-end",
          columnClass: "text-end",
        },
      ],
      timezone: "America/New_York",
      isAllUser: false,
      accept: ".jpg, .png",
      selectDeviceList: [
        {
          name: "All",
          code: null,
        },
        {
          name: "Installed",
          code: true,
        },
        {
          name: "Not yet",
          code: false,
        },
      ],
      itemSelected: null,
      checkAllUser: false,
    };
  },
  computed: {
    targetUsersIds() {
      return this.usersGetNoti.map((x) => x.id);
    },
  },
  methods: {
    setPageDefault() {
      this.paging = {
        page: 1,
        size: 10,
        total: 0,
      };
    },
    async getAllUser(isAllUser) {
      this.clearUsers();
      if (isAllUser) {
        this.investorDataLoading = true;
        const res = await adminServices.findAllInvestors({
          filteredName: this.filteredName,
          filteredEmail: this.filteredEmail,
          hasDevice: this.filteredStatus,
        });
        if (res && res.data && res.data.ok) {
          this.rows = res.data.d;
        }
        this.investorDataLoading = false;
      } else {
        this.getInvestors();
      }
    },
    show(props) {
      this.state = "VIEW";
      this.isShow = true;
      this.useSchedule = true;
      this.selectNotiById(props.notification_id);
    },
    create() {
      this.isShow = true;
      this.state = "CREATE";
      this.getAllUser(false);
    },
    async selectNotiById(id) {
      this.loadingView = true;
      const result = await adminServices.getNotiById(id);
      if (result.data.ok) {
        this.title = result.data.d.content_title;
        this.content = result.data.d.content_body;
        this.url = result.data.d.thumbnail;
        this.rows = result.data.d.target_users;
        if (result.data.d.schedule) {
          this.tmpDate = mapTime(result.data.d.schedule);
          this.datetime = convertTimeTZ(result.data.d.schedule);
        }
        this.loadingView = false;
      }
    },
    customFormatter(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    customFormatterTime(date) {
      return moment(date).format("HH:MM");
    },
    selectUser(item) {
      if (this.state !== "CREATE") return;
      if (!this.usersGetNoti.find((p) => p.id === item.id)) {
        this.usersGetNoti.push(item);
        this.errorMsg.selectUser = "";
      } else {
        this.usersGetNoti = this.usersGetNoti.filter((p) => p.id !== item.id);
        if (this.usersGetNoti.length > 0) this.errorMsg.selectUser = "";
      }
    },
    async sendNoti() {
      if (!this.validData()) {
        return;
      }

      this.loading = true;
      function appendArray(form_data, key, value) {
        if (!value) {
          // form_data.append(key, null)
        } else {
          if (typeof value === "object" && value.length) {
            for (let i = 0; i < value.length; i++) {
              form_data.append(`${key}[${i}]`, value[i]);
            }
          } else {
            form_data.append(key, value);
          }
        }

        return form_data;
      }
      let formData = new FormData();
      appendArray(formData, "ContentTitle", this.title);
      appendArray(formData, "ContentBody", this.content);
      appendArray(formData, "TargetUserIds", this.targetUsersIds);
      appendArray(
        formData,
        "Schedule",
        this.useSchedule
          ? this.tmpDate
            ? parseTimeTz({ ...this.tmpDate, ...this.datetime })
            : ""
          : ""
      );
      appendArray(formData, "Thumbnail", this.file);
      const result = await adminServices.createNotification_MESSAGE(formData);
      if (result.data.c == "invalid_notification") {
        this.resetValue();
      }
      if (result.data.ok) {
        notify.success("Your notification was sent successfully!");
        this.reload();
        this.resetValue();
        this.$refs.close.click();
      } else {
        notify.error("Error occur!");
      }
      this.loading = false;
    },
    validData() {
      let flag = true;
      if ($.trim(this.title) === "") {
        this.errorMsg.title = "Please input title";
        flag = false;
      }
      if ($.trim(this.content) === "") {
        this.errorMsg.content = "Please input notification message";
        flag = false;
      }
      if (this.usersGetNoti.length <= 0) {
        this.errorMsg.selectUser = "Please select user";
        flag = false;
      }
      return flag;
    },
    resetValue() {
      this.title = "";
      this.content = "";
    },
    clearUsers() {
      this.usersGetNoti = [];
    },
    getAllUsers() {
      this.usersGetNoti = [];
      this.rows.forEach((el) => {
        this.selectUser(el);
      });
    },
    funcUseSchedule() {
      if (this.state !== "CREATE") {
        return;
      }
      this.useSchedule = !this.useSchedule;
    },
    showAddNotiUsers() {
      this.addNotiUsers = true;
    },
    async getInvestors() {
      this.investorDataLoading = true;
      const res = await adminServices.findAllInvestors({
        filteredName: this.filteredName,
        filteredEmail: this.filteredEmail,
        hasDevice: this.filteredStatus,
      });
      if (res && res.data && res.data.ok) {
        this.rows = res.data.d;
      }
      this.investorDataLoading = false;
    },
    isUserSelecting(props) {
      return this.usersGetNoti.some((x) => x.id === props.id) ? true : false;
    },
    updatePaging(v) {
      this.paging = Object.assign(this.paging, v);
    },
    onSelectAllUser(v, isChecked) {
      this.checkAllUser = isChecked;
      if (isChecked) {
        this.getAllUsers();
      } else {
        this.clearUsers();
      }
    },
    handleSelectUser(v) {
      this.selectUser(v);
    },
  },
  watch: {
    title(v) {
      this.errorMsg.title = null;
    },
    content(v) {
      this.errorMsg.content = null;
    },
    paging() {
      debounce(this.getInvestors);
    },
    filteredName() {
      this.setPageDefault();
      debounce(this.getInvestors);
    },
    filteredEmail() {
      this.setPageDefault();
      debounce(this.getInvestors);
    },
    filteredStatus() {
      this.setPageDefault();
      debounce(this.getInvestors);
    },
    columns: {
      deep: true,
      handler(v) {
        let col = v.find((p) => typeof p.sort === "boolean" && p.sort);
        this.orderBy = col ? `${col.id} ${col.direction}` : "";
      },
    },
  },
});
